import type { z } from "zod/v4";

export interface DirEndpoint<TResponse extends z.ZodType> {
  /** Resource identifier (e.g., "me/tenants") */
  resource: string;
  /** API path */
  path: string;
  /** Response schema for parsing */
  responseSchema: TResponse;
}

export function defineEndpoint<TResponse extends z.ZodType>(config: DirEndpoint<TResponse>): DirEndpoint<TResponse> {
  return config;
}
